<template>
    <v-switch
        v-bind="$attrs"
        v-on="$listeners"
    >
        <slot
            v-for="(_, name) in $slots"
            :name="name"
            :slot="name"
        />

        <template
            v-for="(_, name) in $scopedSlots"
            v-slot:[name]="slotData"
        >
            <slot
                v-bind="slotData"
                :name="name"
            />
        </template>
    </v-switch>
</template>

<script>
export default {
    name: "BaseInputSwitch",
    inheritAttrs: false,
}
</script>